/* ==========================================================================
   SOBO Redesign — scroll reveal controller
   Include once in layout/theme.liquid before </body>:
     {{ 'sobo-animations.js' | asset_url | script_tag }}
   Respects prefers-reduced-motion automatically (CSS handles the opt-out;
   this script just toggles the class).
   ========================================================================== */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.sobo-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  function observeAll() {
    document.querySelectorAll('.sobo-reveal:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Re-scan when Shopify's theme editor swaps section content in/out
  document.addEventListener('shopify:section:load', observeAll);
})();
